import React, { useState } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Checkbox,
  Typography
} from '@mui/material';
import { Search } from '@mui/icons-material';

const CustomerMultiSelect = ({
  value = [],
  options = [],
  onChange,
  size = 'small',
  fullWidth = true,
  sx = {}
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [open, setOpen] = useState(false);

  const filteredOptions = options.filter(opt =>
    String(opt).toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectChange = event => {
    const newVal = event.target.value;
    onChange(Array.isArray(newVal) ? newVal : []);
  };

  const handleClearAll = e => {
    e.preventDefault();
    e.stopPropagation();
    onChange([]);
  };

  return (
    <FormControl size={size} fullWidth={fullWidth} sx={sx}>
      <InputLabel sx={{ fontSize: '0.75rem' }}>Customer</InputLabel>
      <Select
        multiple
        value={value}
        label='Customer'
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => {
          setOpen(false);
          setSearchTerm('');
        }}
        onChange={handleSelectChange}
        renderValue={selected =>
          selected.length === 0 ? null : `${selected.length} selected`
        }
        sx={{ fontSize: '0.75rem' }}
        MenuProps={{
          PaperProps: { style: { maxHeight: 400, width: 290 } },
          autoFocus: false
        }}
      >
        {/* Search field */}
        <MenuItem
          disableRipple
          sx={{ p: 0, '&:hover': { backgroundColor: 'transparent' } }}
        >
          <TextField
            size='small'
            placeholder='Search Customer...'
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            onClick={e => e.stopPropagation()}
            onKeyDown={e => e.stopPropagation()}
            fullWidth
            autoFocus
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <Search fontSize='small' />
                </InputAdornment>
              )
            }}
            sx={{
              fontSize: '0.75rem',
              '& .MuiOutlinedInput-root': {
                '& fieldset': { border: 'none' }
              }
            }}
          />
        </MenuItem>

        {/* Clear All */}
        {value.length > 0 && (
          <MenuItem
            disableRipple
            onMouseDown={handleClearAll}
            sx={{ fontSize: '0.72rem', color: 'error.main', py: 0.5 }}
          >
            Clear All ({value.length} selected)
          </MenuItem>
        )}

        {/* Options */}
        {filteredOptions.length === 0 ? (
          <MenuItem
            disabled
            sx={{ opacity: 0.7, fontStyle: 'italic', fontSize: '0.75rem' }}
          >
            No results found
          </MenuItem>
        ) : (
          filteredOptions.map(option => (
            <MenuItem
              key={option}
              value={option}
              sx={{ fontSize: '0.75rem', py: 0.5 }}
            >
              <Checkbox
                checked={value.includes(option)}
                size='small'
                sx={{ p: 0.5, mr: 0.5 }}
              />
              <Typography noWrap sx={{ fontSize: '0.75rem' }}>
                {option}
              </Typography>
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default CustomerMultiSelect;
